function Home({ setActivePage }) {
  return (
    <div>
      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #2d2d5e 100%)',
        borderRadius: '12px',
        padding: '40px 24px',
        textAlign: 'center',
        marginBottom: '24px'
      }}>
        <img src={require('../BYG_with_background_color.png')} alt="BYG" style={{ height: '80px', marginBottom: '16px', borderRadius: '8px' }} />
        <h1 style={{ color: 'white', fontSize: '24px', margin: '0 0 8px' }}>BYG Deal Desk</h1>
        <p style={{ color: '#c9a84c', fontSize: '14px', margin: '0 0 16px', fontWeight: 'bold' }}>
          Real Estate, Tax Deed & Lien Investing — Simplified
        </p>
        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '13px', margin: '0 0 24px', lineHeight: '1.6' }}>
          All-in-one platform for analyzing and tracking real estate deals, with an emphasis on tax deed and lien investment opportunities across the US.
        </p>
        <button
          onClick={() => setActivePage('Cheat Sheet')}
          style={{
            backgroundColor: '#c9a84c', color: '#1a1a2e', border: 'none',
            padding: '12px 28px', borderRadius: '6px', cursor: 'pointer',
            fontWeight: 'bold', fontSize: '14px'
          }}
        >
          Get Started →
        </button>
      </div>

      {/* Features Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '12px', marginBottom: '24px' }}>
        {[
          {
            icon: '📋',
            title: 'State Playbook',
            description: 'Know the rules before you bid. Every state\'s penalty rates, redemption periods, and auction schedules in one place.',
            tab: 'Cheat Sheet'
          },
          {
            icon: '🧮',
            title: 'Deal Calculator',
            description: 'Run your numbers instantly. Calculate cash-on-cash returns for both sale and rental scenarios with your own thresholds.',
            tab: 'Deal Calculator'
          },
          {
            icon: '📅',
            title: 'Auction Tracker',
            description: 'Never miss a deadline. Track upcoming auctions, registration deadlines, and deposit requirements by county.',
            tab: 'Auction Tracker'
          },
          {
            icon: '🏛️',
            title: 'Auction Platforms',
            description: 'GovEase, RealAuction, Bid4Assets, LienHub and more — all in one directory with county-level details.',
            tab: 'Auction Platforms'
          },
          {
            icon: '🔍',
            title: 'Due Diligence',
            description: 'Track every property you research. Log lien flags, condition notes, comps, and your final bid decision.',
            tab: 'Due Diligence'
          },
          {
            icon: '🤖',
            title: 'AI Research Agent',
            description: 'Enter an address and let AI research comparable sales, lien risks, ARV estimates, and investment analysis in seconds.',
            tab: 'AI Research'
          },
        ].map((feature, i) => (
          <div
            key={i}
            onClick={() => feature.tab && setActivePage(feature.tab)}
            style={{
              backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '8px',
              padding: '16px', boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
              cursor: feature.tab ? 'pointer' : 'default',
              opacity: feature.tab ? 1 : 0.7
            }}
          >
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>{feature.icon}</div>
            <h3 style={{ margin: '0 0 6px', fontSize: '14px', color: '#1a1a2e' }}>{feature.title}</h3>
            <p style={{ margin: 0, fontSize: '12px', color: '#666', lineHeight: '1.5' }}>{feature.description}</p>
            {feature.tab && (
              <p style={{ margin: '10px 0 0', fontSize: '11px', color: '#c9a84c', fontWeight: 'bold' }}>Open →</p>
            )}
            {!feature.tab && (
              <p style={{ margin: '10px 0 0', fontSize: '11px', color: '#888' }}>Coming Soon</p>
            )}
          </div>
        ))}
      </div>

      {/* Why Tax Deeds Section */}
      <div style={{ backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '8px', padding: '20px', marginBottom: '24px', boxShadow: '0 2px 4px rgba(0,0,0,0.08)' }}>
        <h2 style={{ fontSize: '16px', color: '#1a1a2e', marginBottom: '16px' }}>Why Tax Deed & Lien Investing?</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '12px' }}>
          {[
            { stat: '50', label: 'States with tax deed or lien systems' },
            { stat: '3,000+', label: 'Counties hold auctions annually' },
            { stat: '$0', label: 'Broker fees at auction' },
            { stat: 'You', label: 'Set your own return thresholds' },
          ].map(({ stat, label }) => (
            <div key={label} style={{ textAlign: 'center', padding: '12px', backgroundColor: '#f8f8f8', borderRadius: '8px' }}>
              <p style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', color: '#c9a84c' }}>{stat}</p>
              <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#666' }}>{label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Footer note */}
      <p style={{ textAlign: 'center', fontSize: '11px', color: '#aaa', margin: '8px 0 24px' }}>
        Built by Better Yet Group LLC · For educational and research purposes only
      </p>
    </div>
  );
}

export default Home;
